export const InventoryTableColumns = [
    { id: "product",     labelEn: "Product",      labelAr: "المنتج",        align: "left",   sortable: false },
    { id: "warehouse",   labelEn: "Warehouse",    labelAr: "المستودع",      align: "center", sortable: false },
    { id: "on_hand",     labelEn: "On Hand",      labelAr: "المتاح فعلياً",  align: "center", sortable: false },
    { id: "reserved",    labelEn: "Reserved",     labelAr: "محجوز",         align: "center", sortable: false },
    { id: "available",   labelEn: "Available",    labelAr: "المتاح للبيع",   align: "center", sortable: false },
    { id: "updated_at",  labelEn: "Last Update",  labelAr: "آخر تحديث",     align: "center", sortable: false },
];
